import { render, staticRenderFns } from "./T13.vue?vue&type=template&id=ad1fff92&"
import script from "./T13.vue?vue&type=script&lang=js&"
export * from "./T13.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports